import React, { useState } from 'react';
import { Container, ExpandableSection, SpaceBetween, Header, Box } from '@amzn/awsui-components-core';

export const DisclaimerContainer: React.FC = () => {
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(true);
  const [isDataSourcesExpanded, setIsDataSourcesExpanded] = useState(true);
  const [isBetaStatusExpanded, setIsBetaStatusExpanded] = useState(true);
  const [isHumanReviewExpanded, setIsHumanReviewExpanded] = useState(true);

  return (
    <Container
      header={
        <Header variant="h2">
          <span>AI-Generated Content — What to Know</span>
        </Header>
      }
    >
      <Box fontSize="body-s">
        <SpaceBetween size="m">
          <ExpandableSection
            headerText="Treat Cards as a Starting Point"
            expanded={isDisclaimerExpanded}
            onChange={() => setIsDisclaimerExpanded(!isDisclaimerExpanded)}
          >
            <p>
              This tool uses generative AI to draft baseball-card summaries for talent reviews. They are informational only, not a source of truth and
              do not replace your own judgment in formal performance evaluations.
            </p>
          </ExpandableSection>

          <ExpandableSection
            headerText="Where the Data Comes From"
            expanded={isDataSourcesExpanded}
            onChange={() => setIsDataSourcesExpanded(!isDataSourcesExpanded)}
          >
            <p>Each card draws from a limited set of internal sources:</p>
            <br />
            <ul>
              <li>• Profile &amp; role: Job history and work summary from Phone Tool and related APIs.</li>
              <li>
                • Contributions: Ownership, role summaries, and highlights pulled from code commits, SIM, COEs, peer reviews, metrics, and Kingpin.
              </li>
            </ul>
            <br />
            <p>
              Because the source set is intentionally narrow, cards may be incomplete, out of date, may over-weight certain types of work, or may not
              capture the full picture of someone's impact, scope, or contributions.
            </p>
          </ExpandableSection>

          <ExpandableSection
            headerText="Continuously Refined"
            expanded={isBetaStatusExpanded}
            onChange={() => setIsBetaStatusExpanded(!isBetaStatusExpanded)}
          >
            <p>
              This tool was piloted in Q1 2026 and has been improving since. Metrics, prompts, and data mappings continue to evolve — accuracy and
              consistency will keep getting better. Your feedback directly shapes what comes next.
            </p>
          </ExpandableSection>

          <ExpandableSection
            headerText="You Own the Final Review"
            expanded={isHumanReviewExpanded}
            onChange={() => setIsHumanReviewExpanded(!isHumanReviewExpanded)}
          >
            <p>
              Always review, verify, and layer in your own context before using a card in any decision, document, or downstream process. By using this
              tool you acknowledge these limitations and agree to share feedback that improves future versions.
            </p>
          </ExpandableSection>
        </SpaceBetween>
      </Box>
    </Container>
  );
};
